import { External } from "assets/icons/Common";
import { Col, HorizontalLine, PlayEdLogo } from "components/primitives";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { openInNewTab } from "util/openInNewTap";

import { Toolbar } from "./Toolbar";
import { SegmentProps } from "./ToolbarContainer";
import { ToolbarHeaderButton } from "./ToolbarHeaderButton";

export const MainToolbar: FC<SegmentProps> = ({
  widgetCounts,
  addWidget,
  setCurrentSegment,
  loading = true,
}) => {
  const history = useHistory();
  const navigateTo = (path: string) => {
    history.push(path);
  };

  const REACT_APP_PARENT_ORIGIN =
    process.env.REACT_APP_PARENT_ORIGIN || "https://topteacher.com.au/";
  return (
    <>
      {loading && <div style={{ height: "60px", marginTop: "5px", width: "200px" }}></div>}
      {!loading && <PlayEdLogo />}

      <HorizontalLine margin="1em 0" />
      <TopButtonContainer>
        <ToolbarHeaderButton onClick={() => openInNewTab(REACT_APP_PARENT_ORIGIN)}>
          Resources <External height={"60%"} />
        </ToolbarHeaderButton>
        <ToolbarHeaderButton onClick={() => navigateTo("/my-dashboard")}>
          My Dashboard
        </ToolbarHeaderButton>
        <ToolbarHeaderButton onClick={() => setCurrentSegment("settings")}>
          Settings
        </ToolbarHeaderButton>
      </TopButtonContainer>
      <Toolbar widgetCounts={widgetCounts} addWidget={addWidget} />
    </>
  );
};

const TopButtonContainer = styled(Col)`
  width: 100%;
  gap: 8px;
  margin-bottom: 18px;
`;
